import { useTranslation } from "react-i18next";

import { DA_ITEM_NAMES } from "../selectors/digitalAccess";

/**
 * A nota do documento subsequente gerado por job (#1713, cartão 5.1), no quadro do
 * Ato 1 e no bloco de Digital Access do nó 06. Sem regra automática de exclusão: o
 * consultor exclui o usuário do job na tela de usuários técnicos.
 */
export function SubsequentDocumentNote({
  items,
  testId,
  className,
}: {
  items: readonly string[];
  testId: string;
  className?: string;
}) {
  const { t } = useTranslation();
  if (items.length === 0) return null;
  return (
    <p data-testid={testId} className={className}>
      {t(
        'The count of {{items}} may include subsequent documents created by a job (for example, billing in batch from the delivery), which the contract does not charge. Exclude the job\'s user in "See technical users", in the Diagnostic.',
        { items: items.map((itemId) => `${DA_ITEM_NAMES[itemId] ?? itemId} (${itemId})`).join(", ") },
      )}
    </p>
  );
}
